module.exports = __webpack_public_path__ + "img/47_21.cf7105d0.png";